module.exports = __webpack_public_path__ + "img/slider_3.65433cca.jpg";